<div class="inbox-overlay" [style.left.px]="sidebarWidth">

  <!-- Backdrop: cobre o restante da tela; clicar fecha o painel -->
  <div class="inbox-overlay__backdrop" role="button" tabindex="0" (click)="close()" (keydown.enter)="close()" (keydown.space)="close()"></div>

  <!-- Painel de notificações -->
  <div class="inbox-overlay__panel">

    <!-- Header -->
    <div class="inbox-panel-header">
      <span class="inbox-panel-header__title">{{ 'INBOX.TITLE' | translate }}</span>
      <div class="inbox-panel-header__actions">

        <!-- Filtro (multi-select) -->
        <button mat-icon-button class="inbox-icon-btn" [title]="'INBOX.FILTER.TOOLTIP' | translate" [matMenuTriggerFor]="filterMenu"
          [class.inbox-icon-btn--active]="hasActiveFilters">
          <i-tabler name="filter" class="icon-18"></i-tabler>
        </button>
        <mat-menu #filterMenu="matMenu" panelClass="inbox-filter-menu">
          <button mat-menu-item (click)="$event.stopPropagation(); clearFilters()"
            [class.inbox-filter-active]="!hasActiveFilters">
            {{ 'INBOX.FILTER.ALL' | translate }}
          </button>

          <mat-divider></mat-divider>
          <p class="inbox-menu-section-label">{{ 'INBOX.FILTER.STATUS_SECTION' | translate }}</p>

          <button *ngFor="let opt of statusOptions" mat-menu-item
            (click)="$event.stopPropagation(); toggleFilter(opt.filter)"
            [class.inbox-filter-active]="isActive(opt.filter)">
            {{ opt.label | translate }}
          </button>

          <mat-divider></mat-divider>
          <p class="inbox-menu-section-label">{{ 'INBOX.FILTER.CATEGORIES_SECTION' | translate }}</p>

          <button *ngFor="let opt of categoryOptions" mat-menu-item
            (click)="$event.stopPropagation(); toggleFilter(opt.filter)"
            [class.inbox-filter-active]="isActive(opt.filter)">
            {{ opt.translateLabel ? (opt.label | translate) : opt.label }}
          </button>
        </mat-menu>

        <!-- Mais opções -->
        <button mat-icon-button class="inbox-icon-btn" [title]="'INBOX.OPTIONS.TOOLTIP' | translate" [matMenuTriggerFor]="optionsMenu">
          <i-tabler name="dots" class="icon-18"></i-tabler>
        </button>
        <mat-menu #optionsMenu="matMenu" panelClass="inbox-options-menu">
          <button mat-menu-item (click)="markAllAsRead()">
            <i-tabler name="checks" class="icon-16 inbox-menu-icon"></i-tabler>
            {{ 'INBOX.OPTIONS.MARK_ALL_READ' | translate }}
          </button>
          <button mat-menu-item (click)="archiveAll()">
            <i-tabler name="archive" class="icon-16 inbox-menu-icon"></i-tabler>
            {{ 'INBOX.OPTIONS.ARCHIVE' | translate }}
          </button>
        </mat-menu>

      </div>
    </div>

    <!-- Chips dos filtros ativos -->
    <div *ngIf="hasActiveFilters" class="inbox-filter-bar">
      <span *ngFor="let opt of activeFilterList" class="inbox-filter-bar__chip">
        {{ opt.translateLabel ? (opt.label | translate) : opt.label }}
        <button class="inbox-filter-bar__clear" (click)="removeFilter(opt.filter)">
          <i-tabler name="x" class="icon-12"></i-tabler>
        </button>
      </span>
      <button class="inbox-filter-bar__clear-all" (click)="clearFilters()">{{ 'INBOX.FILTER.CLEAR' | translate }}</button>
    </div>

    <!-- Lista de notificações -->
    <div class="inbox-panel-list">

      <!-- Loading -->
      <div *ngIf="isLoading" class="inbox-loading-state">
        <mat-spinner diameter="32"></mat-spinner>
      </div>

      <ng-container *ngIf="!isLoading">
      <ng-container *ngFor="let group of filteredGroups; trackBy: trackByGroup">
        <div class="inbox-group-label">{{ group.label }}</div>

        <div
          *ngFor="let notification of group.notifications; trackBy: trackByNotification"
          class="inbox-notification-item"
          [class.inbox-notification-item--selected]="selectedNotification?.id === notification.id"
          [class.inbox-notification-item--unread]="!notification.isRead"
          [class.inbox-notification-item--critical]="notification.isCritical"
          [title]="notificationTooltip(notification)"
          role="button"
          tabindex="0"
          (click)="selectNotification(notification)"
          (keydown.enter)="selectNotification(notification)"
        >
          <div class="inbox-notification-avatar">
            <ng-container *ngIf="notification.type === EInboxNotificationType.RECURRENCE">
              <div class="inbox-notification-avatar__icon inbox-notification-avatar__icon--recurrence">
                <i-tabler name="refresh" class="icon-16"></i-tabler>
              </div>
            </ng-container>
            <ng-container *ngIf="notification.type === EInboxNotificationType.RETENTION">
              <div class="inbox-notification-avatar__icon inbox-notification-avatar__icon--retention"
                [class.inbox-notification-avatar__icon--retention-critical]="notification.isCritical">
                <i-tabler name="trash" class="icon-16"></i-tabler>
              </div>
            </ng-container>
            <ng-container
              *ngIf="notification.type !== EInboxNotificationType.RECURRENCE && notification.type !== EInboxNotificationType.RETENTION">
              <div class="inbox-notification-avatar__initials">
                {{ notification.actorInitials }}
              </div>
            </ng-container>
          </div>

          <div class="inbox-notification-content">
            <p class="inbox-notification-content__title">
              <span *ngIf="notification.actorName" class="actor-name">{{ notification.actorName }} </span>
              <span [innerHTML]="notification.title"></span>
            </p>

<p *ngIf="notification.description" class="inbox-notification-content__description">
              {{ notification.description }}
            </p>
          </div>

          <div *ngIf="!notification.isRead" class="inbox-notification-unread-dot"></div>
        </div>
      </ng-container>

      <!-- Estado vazio -->
      <div *ngIf="filteredGroups.length === 0" class="inbox-empty-state">
        <i-tabler name="inbox" class="icon-40"></i-tabler>
        <p>{{ 'INBOX.EMPTY' | translate }}</p>
      </div>
      </ng-container>

    </div>

  </div>
</div>
